export enum ReviewTabs {
  RESIDENTS,
  INVITATIONS_SENT,
  REVIEWS_RECIEVED,
  ALL_REVIEWS,
  PAUSED_RESIDENTS
}
